/**
 * Calculates rounded percentage when given a number and the total amount
 * @param {number} value The number to calculate the percentage of
 * @param {number} total The total amount
 * @return {number} result Returns a rounded percentage
 */
export function tryParseFloat(value: unknown): number | undefined {
  const parsed = Number.parseFloat(value as string);

  return isNaN(value as number) || isNaN(parsed) ? undefined : parsed;
}

export function tryParseInt(value: unknown): number | undefined {
  const parsed = Number.parseInt(value as string);

  return isNaN(value as number) || isNaN(parsed) ? undefined : parsed;
}
